import { ProductCardPriceRange, VariantPriceRange } from "../../types/types";
import {
  determinePriceRange,
  isPriceAtLeastMinimumThreshold,
  getCreditMessage,
} from "../__shared__/PriceUtils/priceUtils";

export const transformVariantPriceRange = (
  variantPriceRange: VariantPriceRange,
): ProductCardPriceRange => {
  const { value, reductionHistory } = variantPriceRange;

  const price: ProductCardPriceRange = {
    was: "",
    then1: "",
    then2: "",
    now: determinePriceRange(value ?? ""),
  };

  if (reductionHistory) {
    if (reductionHistory[0]?.display)
      price.was = determinePriceRange(reductionHistory[0].display);
    if (reductionHistory[1]?.display)
      price.then1 = determinePriceRange(reductionHistory[1].display);
    if (reductionHistory[2]?.display)
      price.then2 = determinePriceRange(reductionHistory[2].display);
  }

  return price;
};

export { isPriceAtLeastMinimumThreshold, getCreditMessage };
